(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('group-type', {
            parent: 'entity',
            url: '/group-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER_ADMIN','ROLE_USER'],
                pageTitle: 'trakeyeApp.groupType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-type/group-types.html',
                    controller: 'GroupTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    $translatePartialLoader.addPart('layout');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('group-type-detail', {
            parent: 'entity',
            url: '/group-type/{id}',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-type/group-type-detail.html',
                    controller: 'GroupTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    $translatePartialLoader.addPart('layout');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('group-type-detail.edit', {
            parent: 'group-type-detail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/group-type/group-type-dialog.html',
                    controller: 'GroupTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
       
        
        .state('group-type.new', {
            parent: 'group-type',
            url: '/new',
            data: {
            	 authorities: ['ROLE_USER_ADMIN']
            },
			views:{
				'content@':{
					 templateUrl: 'app/entities/group-type/group-type-dialog.html',
	                    controller: 'GroupTypeDialogController',
	                    controllerAs: 'vm',
				}
			},
			 resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                description: null,
                                layout: null,
                                colorcode: null,
                                createDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
            
        })
        
        .state('group-type.edit', {
            parent: 'group-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER_ADMIN'],
                pageTitle: 'trakeyeApp.groupType.detail.title'
            },
            views: {
                'content@': {
                	templateUrl: 'app/entities/group-type/group-type-dialog.html',
                    controller: 'GroupTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupType', function($stateParams, GroupType) {
                    return GroupType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        
        .state('group-type.delete', {
            parent: 'group-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-type/group-type-delete-dialog.html',
                    controller: 'GroupTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GroupType', function(GroupType) {
                            return GroupType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group-type', null, { reload: 'group-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
